import useLocationStateStack from "./useLocationStateStack";

export default function useAppOverlayHistory(items, options) {
  return useLocationStateStack("appOverlayStack", items, options);
}
